var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStaderInput = function SvgStaderInput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.402.768c.449.052.734.508.584.935l-2.198 6.245a.705.705 0 0 1-1.264.14l-.47-.753-8.484 5.302-.872-1.396a4.76 4.76 0 0 1 1.515-6.56l4.446-2.779-.513-.822A.705.705 0 0 1 7.825.006l6.577.762Zm-8.895 14.48A6.407 6.407 0 0 0 3.162 24l8.63-4.983a4.76 4.76 0 0 0 1.743-6.503l-.823-1.426-7.205 4.16Z",
    fill: "#A1B6BA"
  })));
};
export default SvgStaderInput;